<template>
	<div v-if="!formReady" class="section">
		<loader/>
	</div>
	<form v-else-if="formReady" class="sections wide" @submit.prevent="submit">
		<section class="section">
			<fieldset>
				<div>
					<div>
						<legend><span>Introducer</span></legend>
					</div>
					<div>
						<label><span>Introducer </span>
							<div v-if="form.errors.get('introducer')" class="error-block">
								<p v-html="form.errors.get('introducer')"></p>
							</div>
							<select v-model="form.data.introducer" @change="prefillFees()">
								<option selected value="">—</option>
								<option
									v-for="(introducer, introducerIndex) in form.options.introducers"
									:key="introducerIndex"
									:value="introducer.id"
									v-html="introducer.profile.name"/>
							</select>
						</label>
					</div>
				</div>
			</fieldset>
		</section>
		<section class="section">
			<fieldset>
				<div>
					<div>
						<legend><span>Conveyancing Fees</span></legend>
					</div>
					<div>
						<div class="fee-fields">
							<label class="input-group"><span>Sale Transaction Value Fees </span>
								<div>
									<div
										v-for="(data, index) in form.data.fees.conveyancing.sale.fee_transaction_bands"
										class="input-grid--fees input-grid--bands">
										<label class="limit"><span>Up To (k) </span>
											<div
												v-if="index < form.data.fees.conveyancing.sale.fee_transaction_bands.length - 1">
												<input
													v-model="form.data.fees.conveyancing.sale.fee_transaction_bands[index].upto" step="1"
													type="number">
											</div>
										</label>
										<label class="fee"><span>Fee </span>
											<div>
												<input
													v-model="form.data.fees.conveyancing.sale.fee_transaction_bands[index].fee" step="1"
													type="number">
											</div>
										</label>
										<label class="repeater-controls">
											<button
												class="repeater-controls__add"
												@click.prevent="addFeeBand('sale', index)">Add
											</button>
											<button
												class="repeater-controls__remove"
												@click.prevent="removeFeeBand('sale', index)">Remove
											</button>
										</label>
									</div>
								</div>
							</label>
							<label class="input-group"><span>Purchase Transaction Value Fees </span>
								<div>
									<div
										v-for="(data, index) in form.data.fees.conveyancing.purchase.fee_transaction_bands"
										class="input-grid--fees input-grid--bands">
										<label class="limit"><span>Up To (k) </span>
											<div
												v-if="index < form.data.fees.conveyancing.purchase.fee_transaction_bands.length - 1">
												<input
													v-model="form.data.fees.conveyancing.purchase.fee_transaction_bands[index].upto" step="1"
													type="number">
											</div>
										</label>
										<label class="fee"><span>Fee </span>
											<div>
												<input
													v-model="form.data.fees.conveyancing.purchase.fee_transaction_bands[index].fee" step="1"
													type="number">
											</div>
										</label>
										<label class="repeater-controls">
											<button
												class="repeater-controls__add"
												@click.prevent="addFeeBand('purchase', index)">Add
											</button>
											<button
												class="repeater-controls__remove"
												@click.prevent="removeFeeBand('purchase', index)">Remove
											</button>
										</label>
									</div>
								</div>
							</label>
							<label class="input-group"><span>Remortgage Transaction Value Fees </span>
								<div>
									<div
										v-for="(data, index) in form.data.fees.conveyancing.remortgage.fee_transaction_bands"
										class="input-grid--fees input-grid--bands">
										<label class="limit"><span>Up To (k) </span>
											<div
												v-if="index < form.data.fees.conveyancing.remortgage.fee_transaction_bands.length - 1">
												<input
													v-model="form.data.fees.conveyancing.remortgage.fee_transaction_bands[index].upto" step="1"
													type="number">
											</div>
										</label>
										<label class="fee"><span>Fee </span>
											<div>
												<input
													v-model="form.data.fees.conveyancing.remortgage.fee_transaction_bands[index].fee" step="1"
													type="number">
											</div>
										</label>
										<label class="repeater-controls">
											<button
												class="repeater-controls__add"
												@click.prevent="addFeeBand('remortgage', index)">Add
											</button>
											<button
												class="repeater-controls__remove"
												@click.prevent="removeFeeBand('remortgage', index)">Remove
											</button>
										</label>
									</div>
								</div>
							</label>
						</div>
						<div class="fee-fields">
							<label class="input-group"><span>Telegraphic Transfer Fee </span>
								<div class="input-grid--fees">
									<label class="sale"><span>Sale </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.sale.fee_telegraphic_transfer" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
									<label class="purchase"><span>Purchase </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.purchase.fee_telegraphic_transfer" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
									<label class="remortgage"><span>Remortgage </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.remortgage.fee_telegraphic_transfer" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
								</div>
							</label>
							<label
								v-if="serviceProvider.config.offers_leasehold_transactions"
								class="input-group"><span>Leasehold Property Fee </span>
								<div class="input-grid--fees">
									<label class="sale"><span>Sale </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.sale.fee_leasehold_property" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
									<label class="purchase"><span>Purchase </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.purchase.fee_leasehold_property" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
									<label class="remortgage"><span>Remortgage </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.remortgage.fee_leasehold_property" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
								</div>
							</label>
							<label
								v-if="serviceProvider.config.offers_islamic_mortgage_transactions"
								class="input-group"><span>Islamic Mortgage Fee </span>
								<div class="input-grid--fees">
									<label class="sale"><span>Sale </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.sale.fee_islamic_mortgage" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
									<label class="purchase"><span>Purchase </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.purchase.fee_islamic_mortgage" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
									<label class="remortgage"><span>Remortgage </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.remortgage.fee_islamic_mortgage" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
								</div>
							</label>
							<label
								v-if="serviceProvider.config.offers_new_build_transactions"
								class="input-group"><span>New Build Fee </span>
								<div class="input-grid--fees">
									<label class="sale"><span>Sale </span>
										<p class="not-applicable">Not Applicable</p>
									</label>
									<label class="purchase"><span>Purchase </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.purchase.fee_new_build" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
									<label class="remortgage"><span>Remortgage </span>
										<p class="not-applicable">Not Applicable</p>
									</label>
								</div>
							</label>
							<label class="input-group"><span>Shared Ownership Fee </span>
								<div class="input-grid--fees">
									<label class="sale"><span>Sale </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.sale.fee_shared_ownership" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
									<label class="purchase"><span>Purchase </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.purchase.fee_shared_ownership" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
									<label class="remortgage"><span>Remortgage </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.remortgage.fee_shared_ownership" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
								</div>
							</label>
							<label class="input-group"><span>Right To Buy Fee </span>
								<div class="input-grid--fees">
									<label class="sale"><span>Sale </span>
										<p class="not-applicable">Not Applicable</p>
									</label>
									<label class="purchase"><span>Purchase </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.purchase.fee_right_to_buy" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
									<label class="remortgage"><span>Sale </span>
										<p class="not-applicable">Not Applicable</p>
									</label>
								</div>
							</label>
							<label class="input-group"><span>Transfer Of Equity Fee </span>
								<div class="input-grid--fees">
									<label class="sale"><span>Sale </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.sale.fee_transfer_of_equity" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
									<label class="purchase"><span>Purchase </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.purchase.fee_transfer_of_equity" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
									<label class="remortgage"><span>Remortgage </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.remortgage.fee_transfer_of_equity" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
								</div>
							</label>
							<label class="input-group"><span>Auction/Repossession Fee </span>
								<div class="input-grid--fees">
									<label class="sale"><span>Sale </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.sale.fee_auction_repossession" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
									<label class="purchase"><span>Purchase </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.purchase.fee_auction_repossession" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
									<label class="remortgage"><span>Remortgage </span>
										<p class="not-applicable">Not Applicable</p>
									</label>
								</div>
							</label>
							<label class="input-group"><span>Help To Buy Scheme Fee </span>
								<div class="input-grid--fees">
									<label class="sale"><span>Sale </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.sale.fee_help_to_buy_scheme" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
									<label class="purchase"><span>Purchase </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.purchase.fee_help_to_buy_scheme" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
									<label class="remortgage"><span>Remortgage </span>
										<p class="not-applicable">Not Applicable</p>
									</label>
								</div>
							</label>
							<label class="input-group"><span>Help To Buy ISA Fee </span>
								<div class="input-grid--fees">
									<label class="sale"><span>Sale </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.sale.fee_help_to_buy_isa" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
									<label class="purchase"><span>Purchase </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.purchase.fee_help_to_buy_isa" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
									<label class="remortgage"><span>Remortgage </span>
										<p class="not-applicable">Not Applicable</p>
									</label>
								</div>
							</label>
							<label class="input-group"><span>Stamp Duty Form Fee </span>
								<div class="input-grid--fees">
									<label class="sale"><span>Sale </span>
										<p class="not-applicable">Not Applicable</p>
									</label>
									<label class="purchase"><span>Purchase </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.purchase.fee_stamp_duty_form" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
									<label class="remortgage"><span>Remortgage </span>
										<p class="not-applicable">Not Applicable</p>
									</label>
								</div>
							</label>
							<label class="input-group"><span>Mortgage Admin Fee </span>
								<div class="input-grid--fees">
									<label class="sale"><span>Sale </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.sale.fee_mortgage_admin" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
									<label class="purchase"><span>Purchase </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.purchase.fee_mortgage_admin" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
									<label class="remortgage"><span>Remortgage </span>
										<p class="not-applicable">Not Applicable</p>
									</label>
								</div>
							</label>
							<label class="input-group"><span>Lawyer Checker Fee </span>
								<div class="input-grid--fees">
									<label class="sale"><span>Sale </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.sale.fee_lawyer_checker" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
									<label class="purchase"><span>Purchase </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.purchase.fee_lawyer_checker" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
									<label class="remortgage"><span>Remortgage </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.remortgage.fee_lawyer_checker" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
								</div>
							</label>
							<label class="input-group"><span>File Admin Fee </span>
								<div class="input-grid--fees">
									<label class="sale"><span>Sale </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.sale.fee_file_admin" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
									<label class="purchase"><span>Purchase </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.purchase.fee_file_admin" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
									<label class="remortgage"><span>Remortgage </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.remortgage.fee_file_admin" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
								</div>
							</label>
							<label class="input-group"><span>Lender Monitor Fee </span>
								<div class="input-grid--fees">
									<label class="sale"><span>Sale </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.sale.fee_lender_monitor" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
									<label class="purchase"><span>Purchase </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.purchase.fee_lender_monitor" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
									<label class="remortgage"><span>Remortgage </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.remortgage.fee_lender_monitor" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
								</div>
							</label>
						</div>
					</div>
				</div>
			</fieldset>
			<fieldset>
				<div>
					<div>
						<legend><span>Conveyancing Disbursements</span></legend>
					</div>
					<div>
						<div class="fee-fields">
							<label class="input-group"><span>Search Pack </span>
								<div class="input-grid--fees">
									<label class="sale"><span>Sale </span>
										<p class="not-applicable">Not Applicable</p>
									</label>
									<label class="purchase"><span>Purchase </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.purchase.disbursement_search_pack" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
									<label class="remortgage"><span>Remortgage </span>
										<p class="not-applicable">Not Applicable</p>
									</label>
								</div>
							</label>
							<label class="input-group"><span>Bankruptcy Search Fee </span>
								<div class="input-grid--fees">
									<label class="sale"><span>Sale </span>
										<p class="not-applicable">Not Applicable</p>
									</label>
									<label class="purchase"><span>Purchase </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.purchase.disbursement_bankruptcy_search" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
									<label class="remortgage"><span>Remortgage </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.remortgage.disbursement_bankruptcy_search" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
								</div>
							</label>
							<label class="input-group"><span>ID Check Fee </span>
								<div class="input-grid--fees">
									<label class="sale"><span>Sale </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.sale.disbursement_id_check" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
									<label class="purchase"><span>Purchase </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.purchase.disbursement_id_check" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
									<label class="remortgage"><span>Remortgage </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.remortgage.disbursement_id_check" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
								</div>
							</label>
							<label class="input-group"><span>Office Copies & Title Plan Fee </span>
								<div class="input-grid--fees">
									<label class="sale"><span>Sale </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.sale.disbursement_office_copies_title_plan" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
									<label class="purchase"><span>Purchase </span>
										<p class="not-applicable">Not Applicable</p>
									</label>
									<label class="remortgage"><span>Remortgage </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.remortgage.disbursement_office_copies_title_plan" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
								</div>
							</label>
							<label class="input-group"><span>Land Registry Pre Completion Fee </span>
								<div class="input-grid--fees">
									<label class="sale"><span>Sale </span>
										<p class="not-applicable">Not Applicable</p>
									</label>
									<label class="purchase"><span>Purchase </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.purchase.disbursement_land_registry_pre_completion" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
									<label class="remortgage"><span>Remortgage </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.remortgage.disbursement_land_registry_pre_completion" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
								</div>
							</label>
							<label class="input-group"><span>Remortgage No Search Insurance Fee </span>
								<div class="input-grid--fees">
									<label class="sale"><span>Sale </span>
										<p class="not-applicable">Not Applicable</p>
									</label>
									<label class="purchase"><span>Purchase </span>
										<p class="not-applicable">Not Applicable</p>
									</label>
									<label class="remortgage"><span>Remortgage </span>
										<div>
											<input
												v-model="form.data.fees.conveyancing.remortgage.disbursement_remortgage_search_policy" min="0.01" step="0.01"
												type="number"/>
										</div>
									</label>
								</div>
							</label>
							<div class="fieldset-section">
								<header>
									<h2>Other Disbursements</h2>
								</header>
								<label class="inline"><span>ID Check Fee</span>
									<input
										v-model="form.data.fees.conveyancing.other.disbursement_id_check"
										class="number--hundreds" min="0.01" step="0.01"
										type="number"/>
								</label>
							</div>
						</div>
					</div>
				</div>
			</fieldset>
		</section>
		<section class="section">
			<div class="actions-aligned">
				<ul class="actions">
					<li>
						<button class="button button--secondary" @click.prevent="cancel()">Cancel</button>
					</li>
					<li>
						<process-button :processing="form.processing" class="button button--primary" text="Save Fees"/>
					</li>
				</ul>
			</div>
		</section>
	</form>
</template>
<script>

export default {
	data() {
		return {
			formReady: false,
			form: this.newForm({
				introducer: "",
				fees: {
					conveyancing: {
						sale: {
							fee_transaction_bands: [{
								upto: null,
								fee: null,
							}],
							fee_telegraphic_transfer: null,
							fee_leasehold_property: null,
							fee_islamic_mortgage: null,
							fee_new_build: null,
							fee_shared_ownership: null,
							fee_right_to_buy: null,
							fee_transfer_of_equity: null,
							fee_auction_repossession: null,
							fee_help_to_buy_scheme: null,
							fee_help_to_buy_isa: null,
							fee_stamp_duty_form: null,
							fee_mortgage_admin: null,
							fee_lawyer_checker: null,
							fee_buy_to_let: null,
							fee_file_admin: null,
							fee_lender_monitor: null,
							disbursement_search_pack: null,
							disbursement_bankruptcy_search: null,
							disbursement_office_copies_title_plan: null,
							disbursement_land_registry_pre_completion: null,
							disbursement_remortgage_search_policy: null,
							// remove
							disbursement_id_check: null,
						},
						purchase: {
							fee_transaction_bands: [{
								upto: null,
								fee: null,
							}],
							fee_telegraphic_transfer: null,
							fee_leasehold_property: null,
							fee_islamic_mortgage: null,
							fee_new_build: null,
							fee_shared_ownership: null,
							fee_right_to_buy: null,
							fee_transfer_of_equity: null,
							fee_auction_repossession: null,
							fee_help_to_buy_scheme: null,
							fee_help_to_buy_isa: null,
							fee_stamp_duty_form: null,
							fee_mortgage_admin: null,
							fee_lawyer_checker: null,
							fee_buy_to_let: null,
							disbursement_search_pack: null,
							disbursement_bankruptcy_search: null,
							disbursement_office_copies_title_plan: null,
							disbursement_land_registry_pre_completion: null,
							disbursement_remortgage_search_policy: null,
							// remove
							disbursement_id_check: null,
						},
						remortgage: {
							fee_transaction_bands: [{
								upto: null,
								fee: null,
							}],
							fee_telegraphic_transfer: null,
							fee_leasehold_property: null,
							fee_islamic_mortgage: null,
							fee_new_build: null,
							fee_shared_ownership: null,
							fee_right_to_buy: null,
							fee_transfer_of_equity: null,
							fee_auction_repossession: null,
							fee_help_to_buy_scheme: null,
							fee_help_to_buy_isa: null,
							fee_stamp_duty_form: null,
							fee_mortgage_admin: null,
							fee_lawyer_checker: null,
							fee_buy_to_let: null,
							disbursement_search_pack: null,
							disbursement_bankruptcy_search: null,
							disbursement_office_copies_title_plan: null,
							disbursement_land_registry_pre_completion: null,
							disbursement_remortgage_search_policy: null,
							// remove
							disbursement_id_check: null,
						},
						other: {
							fee_transaction_bands: [{
								upto: null,
								fee: null,
							}],
							disbursement_id_check: null,
						},
					},
				},
			}),
		};
	},

	props: {
		serviceProvider: {
			type: Object,
			default() {
				return null;
			},
		},
	},

	methods: {
		prefillFees() {
			_.each(this.serviceProvider.fees, function (fees, serviceKey) {
				fees = fees.introducers[this.form.data.introducer] || fees.introducers[""];
				let mappedFees = _.mapValues(fees.fees, function (fees, type) {
					return _.mapValues(fees, function (data, fee) {
						if ("fee_transaction_bands" === fee) {
							if (!data.length) {
								return this.form.originalData.fees.conveyancing[type].fee_transaction_bands;
							}
							return _.map(data, function (data) {
								return {
									fee: data.fee.float,
									upto: !data.upto ? null : data.upto.wholes / 1000,
								};
							});
						}

						return data ? data.float : null;
					}.bind(this));
				}.bind(this));

				_.each(mappedFees, function (mapped, type) {
					this.form.set("fees." + serviceKey + "." + type, mapped);
				}.bind(this));
			}.bind(this));
		},
		addFeeBand(type, index) {
			this.form.pushDefault("fees.conveyancing." + type + ".fee_transaction_bands", index);
		},
		removeFeeBand(type, index) {
			this.form.removeIndex("fees.conveyancing." + type + ".fee_transaction_bands", index);
		},
		cancel() {
			this.$emit("cancelled", true);
		},
		async submit() {
			this.form.post(
				this.route("service-providers/:serviceProvider/fees", this.serviceProvider),
			).then(data => {
				this.$store.dispatch("alertsStore/success", "Fees Saved");
			});
		},
	},

	created() {
		http().get("form-data/fees", {
			params: {
				serviceProvider: this.serviceProvider.id,
			},
		}).then(response => {
			this.form.setOptions(response.data.options);

			this.form.pushDefault("fees.conveyancing.sale.fee_transaction_bands");
			this.form.pushDefault("fees.conveyancing.purchase.fee_transaction_bands");
			this.form.pushDefault("fees.conveyancing.remortgage.fee_transaction_bands");

			this.prefillFees();

			this.formReady = true;
		});
	},
};
</script>
